module.exports = __webpack_public_path__ + "static/media/logo.2500cc6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/logo.png
// module id = 1023
// module chunks = 0